import React from 'react';
import { Check, ShieldCheck, CreditCard, Lock } from 'lucide-react';
export function PricingSection() {
  return <section id="oferta" className="py-5 sm:py-16 bg-[#0a1628] relative" data-id="element-113">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-114">
        <div className="text-center mb-4 sm:mb-8" data-id="element-115">
          <h2 className="text-xl sm:text-4xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-116">
            Oferta Especial
          </h2>
          <div className="h-0.5 sm:h-1 w-16 sm:w-20 bg-[#fbbf24] mx-auto mt-2 sm:mt-3 rounded-full" data-id="element-117"></div>
        </div>

        {/* MAIN OFFER BOX */}
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden border-4 border-[#fbbf24] mb-5 sm:mb-12" data-id="element-118">
          <div className="bg-[#fbbf24] py-1.5 sm:py-3 text-center" data-id="element-119">
            <span className="text-[#0a1628] font-black text-xs sm:text-lg tracking-wider uppercase" data-id="element-120">
              ⭐ EL KIT MÁS VENDIDO ⭐
            </span>
          </div>

          <div className="p-3 sm:p-8 text-center" data-id="element-121">
            <h3 className="text-lg sm:text-3xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-122">
              Kit Completo Geografía Lista
            </h3>

            <div className="flex flex-col items-center justify-center mb-3 sm:mb-6" data-id="element-123">
              <span className="text-gray-400 text-sm sm:text-xl line-through font-medium mb-0" data-id="element-124">
                $47.900
              </span>
              <span className="text-[#16a34a] text-2xl sm:text-3xl md:text-4xl font-black tracking-tight" data-id="element-125">
                $19.990 ARS
              </span>
            </div>

            <div className="bg-gray-50 rounded-lg p-2.5 sm:p-5 mb-3 sm:mb-6 text-left max-w-sm mx-auto border border-gray-200" data-id="element-126">
              <p className="font-bold text-gray-700 mb-2 sm:mb-3 uppercase text-[10px] sm:text-xs tracking-wide text-center" data-id="element-127">
                Incluye todo esto:
              </p>
              <ul className="space-y-1.5 sm:space-y-2" data-id="element-128">
                {['Kit completo (6 cuadernillos)', 'BONUS Guía Maestra de Planificación Anual', 'BONUS Guía Docente de Primeros Auxilios', 'BONUS Maletín de Actividades', 'Entrega por Drive (PDF)', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-center text-gray-800 font-medium text-xs sm:text-sm" data-id="element-129">
                    <Check className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-130" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="mb-3 sm:mb-5" data-id="element-131">
              <p className="text-[10px] sm:text-xs text-gray-500 mb-1 font-medium" data-id="element-132">
                Medios de pago:
              </p>
              <div className="flex items-center justify-center gap-1 text-gray-700 font-medium bg-gray-100 py-1.5 px-3 rounded-full text-[10px] sm:text-xs inline-flex" data-id="element-133">
                <CreditCard className="h-3 w-3 mr-1 flex-shrink-0" data-id="element-134" />
                <span data-id="element-135">Transferencia · Mercado Pago · Tarjeta</span>
              </div>
            </div>

            <a href="https://checkout.kitonline.shop/cart/47280783327470:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-base sm:text-2xl font-black py-3.5 sm:py-4 px-4 rounded-lg shadow-[0_4px_0_rgb(21,128,61)] hover:shadow-[0_2px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all uppercase mb-2 sm:mb-3" data-id="element-136">
              COMPRAR AHORA →
            </a>

            <div className="flex items-center justify-center text-gray-500 text-[10px] sm:text-xs font-medium mb-2" data-id="element-137">
              <Lock className="h-3 w-3 mr-1" data-id="element-138" />
              PAGO SEGURO CON MERCADO PAGO
            </div>

            <p className="text-gray-500 text-[10px] sm:text-xs" data-id="element-139">
              Luego del pago, te enviamos el acceso por Drive.
            </p>
          </div>
        </div>

        {/* UPSELL BOX */}
        <div className="bg-[#1e293b] rounded-xl shadow-2xl overflow-hidden border border-gray-700 relative" data-id="element-140">
          <div className="absolute top-0 right-0 bg-[#dc2626] text-white text-[9px] sm:text-xs font-bold px-2 py-0.5 sm:py-1 rounded-bl-lg uppercase" data-id="element-141">
            Oferta Limitada
          </div>

          <div className="p-3 sm:p-6 md:p-8" data-id="element-142">
            <div className="text-center mb-3 sm:mb-5" data-id="element-143">
              <span className="inline-block bg-blue-600 text-white text-[9px] sm:text-xs font-bold px-2 py-0.5 rounded-full mb-2 uppercase tracking-wide" data-id="element-144">
                Pack Profesional
              </span>
              <h3 className="text-lg sm:text-2xl font-bold text-white mb-1" data-id="element-145">
                KIT COMPLETO + PACK DE MAPAS EDUCATIVOS
              </h3>

              <div className="flex items-baseline justify-center gap-2 sm:gap-3 mb-3 sm:mb-4" data-id="element-146">
                <span className="text-gray-500 text-sm sm:text-lg line-through" data-id="element-147">
                  $49.990
                </span>
                <span className="text-[#fbbf24] text-2xl sm:text-3xl font-bold" data-id="element-148">
                  $24.980
                </span>
              </div>
            </div>

            {/* Upsell Product Image */}
            <div className="mb-3 sm:mb-5" data-id="element-149">
              <a href="https://checkout.kitonline.shop/cart/47547120812270:1" className="block hover:opacity-90 transition-opacity" data-id="element-150">
                <img src="https://cdn.magicpatterns.com/uploads/wDq7FwHgjyJYcfhW7DHZrm/upsell_geografia.png" alt="Pack Profesional Geografía + Mapas Educativos" className="w-full h-auto rounded-lg shadow-lg max-w-md mx-auto" data-id="element-151" />
              </a>
            </div>

            <div className="flex flex-col md:flex-row gap-3 sm:gap-6 items-center" data-id="element-152">
              {/* Left Content */}
              <div className="flex-1 text-center md:text-left" data-id="element-153">
                <p className="text-gray-400 mb-3 sm:mb-4 text-xs sm:text-sm" data-id="element-154">
                  Explicá todos los temas con mapas claros, listos para usar y
                  fáciles de proyectar o imprimir
                </p>

                <a href="https://checkout.kitonline.shop/cart/47547120812270:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-lg font-bold py-2.5 sm:py-3 px-4 rounded-lg shadow-lg transition-colors text-center mb-2" data-id="element-155">
                  SÍ, QUIERO LA OFERTA →
                </a>

                <div className="flex items-center justify-center md:justify-start text-gray-400 text-[9px] sm:text-xs font-medium" data-id="element-156">
                  <ShieldCheck className="h-3 w-3 mr-1" data-id="element-157" />
                  Pago seguro con Mercado Pago
                </div>
              </div>

              {/* Right Content - Features list */}
              <div className="flex-1 w-full" data-id="element-158">
                <ul className="space-y-1 sm:space-y-1.5 text-[10px] sm:text-xs text-gray-300" data-id="element-159">
                  {['Explicar contenidos complejos de forma más simple', 'Ahorrar tiempo buscando mapas por tu cuenta', 'Hacer tus clases más visuales y dinámicas', 'Mejorar la comprensión de tus alumnos'].map((item, i) => <li key={i} className="flex items-start" data-id="element-160">
                      <div className="min-w-[4px] h-[4px] rounded-full bg-[#fbbf24] mt-1 mr-1.5" data-id="element-161"></div>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* ACTIVITIES GALLERY */}
        <div className="mt-5 sm:mt-10 bg-[#1e293b] rounded-xl border border-gray-700 overflow-hidden" data-id="element-162">
          <div className="bg-[#fbbf24]/10 border-b border-[#fbbf24]/20 py-2.5 sm:py-4 px-3 sm:px-6 text-center" data-id="element-163">
            <h3 className="text-sm sm:text-xl font-bold text-[#fbbf24]" data-id="element-164">
              📚 Estas son algunas de las actividades que encontrarás en el kit
              completo de geografía
            </h3>
          </div>
          <div className="p-3 sm:p-6" data-id="element-165">
            <div className="grid grid-cols-2 gap-2 sm:gap-4" data-id="element-166">
              <a href="https://checkout.kitonline.shop/cart/47280783327470:1" className="block rounded-lg overflow-hidden border border-gray-600 hover:border-[#fbbf24] transition-colors shadow-md hover:shadow-xl" data-id="element-167">
                <img src="https://cdn.magicpatterns.com/uploads/gmoXZRox9B788jnq5uDASt/Captura_de_pantalla_2025-12-15_205604.png" alt="Actividad de Geografía - Integraciones económicas" className="w-full h-auto" data-id="element-168" />
              </a>
              <a href="https://checkout.kitonline.shop/cart/47280783327470:1" className="block rounded-lg overflow-hidden border border-gray-600 hover:border-[#fbbf24] transition-colors shadow-md hover:shadow-xl" data-id="element-169">
                <img src="https://cdn.magicpatterns.com/uploads/7n3mVUMv1k2zZ5PRvSfSQx/Captura_de_pantalla_2025-12-15_205410.png" alt="Actividad de Geografía - Organización del espacio mundial" className="w-full h-auto" data-id="element-170" />
              </a>
              <a href="https://checkout.kitonline.shop/cart/47280783327470:1" className="block rounded-lg overflow-hidden border border-gray-600 hover:border-[#fbbf24] transition-colors shadow-md hover:shadow-xl" data-id="element-171">
                <img src="https://cdn.magicpatterns.com/uploads/oVHcwjx1pWdRcxeQvhndA7/Captura_de_pantalla_2025-12-15_205455.png" alt="Actividad de Geografía - América nuestro continente" className="w-full h-auto" data-id="element-172" />
              </a>
              <a href="https://checkout.kitonline.shop/cart/47280783327470:1" className="block rounded-lg overflow-hidden border border-gray-600 hover:border-[#fbbf24] transition-colors shadow-md hover:shadow-xl" data-id="element-173">
                <img src="https://cdn.magicpatterns.com/uploads/qbPZTJRDq9FqTjxQBPaQRB/Captura_de_pantalla_2025-12-15_205536.png" alt="Actividad de Geografía - División política siglo XX" className="w-full h-auto" data-id="element-174" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}